<div class="content-container m-0">
    <div class="d-flex my-4">
        <div class="login-form mx-auto">
            <form [formGroup]="form" (ngSubmit)="submit()">
                <div class="d-flex mb-3 flex-column">
                    <img class="logo p-4" src="/assets/logo-large.png" alt="Tiwi Land Council" />
                </div>

                <h1 class="h4 mt-0">Choose a password</h1>
                <p class="text-body-secondary">
                    Your account was set up with a temporary password. Choose your own to finish signing in - the temporary one stops working straight away.
                </p>

                @if (error) {
                    <div class="alert alert-danger text-break" role="alert">{{ error }}</div>
                }

                <div class="form-group">
                    <label class="form-label" for="set_password">New password</label>
                    <input class="form-control" type="password" id="set_password" name="password" formControlName="password" autocomplete="new-password" />
                    @if (form.get('password').invalid && (form.get('password').dirty || form.get('password').touched)) {
                        <div class="col-12">
                            @if (form.get('password').errors.required) {
                                <small class="error-text text-danger"
                                    ><span>This value should not be blank.<br /></span
                                ></small>
                            }
                            @if (form.get('password').errors.minlength) {
                                <small class="error-text text-danger"
                                    ><span>Your password should be at least 10 characters<br /></span
                                ></small>
                            }
                        </div>
                    }
                </div>

                <div class="form-group">
                    <label class="form-label" for="set_repeat_password">Repeat password</label>
                    <input
                        class="form-control"
                        type="password"
                        id="set_repeat_password"
                        name="repeatPassword"
                        formControlName="repeatPassword"
                        autocomplete="new-password"
                    />
                    @if (form.get('repeatPassword').invalid && form.get('repeatPassword').touched) {
                        <div class="col-12">
                            @if (form.get('repeatPassword').errors.required) {
                                <small class="error-text text-danger"
                                    ><span>This value should not be blank.<br /></span
                                ></small>
                            }
                            @if (form.get('repeatPassword').errors.confirmedValidator) {
                                <small class="error-text text-danger"
                                    ><span>The password fields must match.<br /></span
                                ></small>
                            }
                        </div>
                    }
                </div>

                <div class="d-flex mt-4">
                    <input type="submit" value="Save password" class="btn btn-primary ms-0 mb-4" [disabled]="!form.valid || loading" />
                </div>
            </form>
        </div>
    </div>
</div>
